const messages = {
  back: 'cambiar centro',
  welcome: '{Name}, la sonrisa de tus sueños esta cerca',
  select: 'Selecciona día y horario',
  noDate: 'No tenemos horarios en este día, selecciona otro'
}

export default messages
